<template>
  <el-card
    header="Pricing and Margin"
    shadow="never"
  >
    <el-table
      :data="createData"
      border
    >
      <el-table-column
        prop="inv_rate"
        label="Inv Rate"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="inv_fees"
        label="Inv Fees"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="inv_fuel"
        label="Inv Fuel"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="buy_rate"
        label="Buy Rate"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="buy_fees"
        label="Buy Fees"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="buy_fuel"
        label="Buy Fuel"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="sell_rate"
        label="Sell Rate"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="sell_fees"
        label="Sell Fees"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="sell_fuel"
        label="Sell Fuel"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="inv_total"
        label="Inv Total"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="buy_total"
        label="Buy Total"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="sell_total"
        label="Sell Total"
        :formatter="(row, col, cellValue) => cellValue ? `$${cellValue.toFixed(2)}` : '-'"
      />
      <el-table-column
        prop="margin"
        label="Margin"
        :formatter="(row, col, cellValue) => cellValue ? `${cellValue.toFixed(2)}%` : '-'"
      />
    </el-table>
  </el-card>
</template>
<script>

export default {
  props: {
    consignment: {
      type: Object,
      required: true
    }
  },
  computed: {
    createData () {
      let data = []
      if (this.consignment.inv_pricing) {
        data['inv_rate'] = this.consignment.inv_pricing.buy_rate
        data['inv_fees'] = this.consignment.inv_pricing.buy_fees
        data['inv_tax'] = this.consignment.inv_pricing.buy_tax
        data['inv_fuel'] = this.consignment.inv_pricing.buy_fuel
        data['sell_rate'] = this.consignment.inv_pricing.sell_rate
        data['sell_fees'] = this.consignment.inv_pricing.sell_fees
        data['sell_tax'] = this.consignment.inv_pricing.sell_tax
        data['sell_fuel'] = this.consignment.inv_pricing.sell_fuel
        data['inv_total'] = this.consignment.inv_pricing.buy_rate + this.consignment.inv_pricing.buy_fees + this.consignment.inv_pricing.buy_fuel
        data['sell_total'] = this.consignment.inv_pricing.sell_rate + this.consignment.inv_pricing.sell_fees + this.consignment.inv_pricing.sell_fuel
      } else {
        data['inv_rate'] = false
        data['inv_fees'] = false
        data['inv_tax'] = false
        data['inv_fuel'] = false
        data['sell_rate'] = false
        data['sell_fees'] = false
        data['sell_tax'] = false
        data['sell_fuel'] = false
        data['inv_total'] = false
        data['sell_total'] = false
      }
      if (this.consignment.con_pricing) {
        data['buy_rate'] = this.consignment.con_pricing.buy_rate
        data['buy_fees'] = this.consignment.con_pricing.buy_fees
        data['buy_tax'] = this.consignment.con_pricing.buy_tax
        data['buy_fuel'] = this.consignment.con_pricing.buy_fuel
        data['buy_total'] = this.consignment.con_pricing.buy_rate + this.consignment.con_pricing.buy_fees + this.consignment.con_pricing.buy_fuel
      } else {
        data['buy_rate'] = false
        data['buy_fees'] = false
        data['buy_tax'] = false
        data['buy_fuel'] = false
        data['buy_total'] = false
      }
      if (this.consignment.inv_pricing && this.consignment.con_pricing) {
        data['margin'] = (((data.sell_total - data.inv_total) / data.sell_total) * 100)
      } else {
        data['margin'] = false
      }
      return [data]
    }
  }
}
</script>
